import { defaultData as ecaudorExportDefaultValues } from "../../routes/intel/default-values/ecuador-export";
import { defaultData as ecaudorImportDefaultValues } from "../../routes/intel/default-values/ecuador-import";
import { defaultData as usExportDefaultValues } from "../../routes/intel/default-values/us-export";
import { defaultData as usImportDefaultValues } from "../../routes/intel/default-values/us-import";
import { defaultData as panamaImportDefaultValues } from "../../routes/intel/default-values/panama-import";
import { defaultData as panamaExportDefaultValues } from "../../routes/intel/default-values/panama-export";
import { defaultData as colombiaImportDefaultValues } from "../../routes/intel/default-values/colombia-import";
import { defaultData as colombiaExportDefaultValues } from "../../routes/intel/default-values/colombia-export";
import { defaultData as argentinaImportDefaultValues } from "../../routes/intel/default-values/argentina-import";
import { defaultData as argentinaExportDefaultValues } from "../../routes/intel/default-values/argentina-export";
import { defaultData as chileImportDefaultValues } from "../../routes/intel/default-values/chile-import";
import { defaultData as chileExportDefaultValues } from "../../routes/intel/default-values/chile-export";
import { defaultData as mexicoImportExportDefaultValues } from "../../routes/intel/default-values/mexico-import";
import { defaultData as mexicoExportExportDefaultValues } from "../../routes/intel/default-values/mexico-export";
import { defaultData as peruImportDefaultValues } from "../../routes/intel/default-values/peru-import";
import { defaultData as peruExportDefaultValues } from "../../routes/intel/default-values/peru-export";
import { defaultData as ukImportDefaultValues } from "../../routes/intel/default-values/uk-import";
import { defaultData as ukExportDefaultValues } from "../../routes/intel/default-values/uk-export";
import { defaultData as uruguayImportDefaultValues } from "../../routes/intel/default-values/uruguay-import";
import { defaultData as uruguayExportDefaultValues } from "../../routes/intel/default-values/uruguay-export";
import { defaultData as philippinesImportDefaultValues } from "../../routes/intel/default-values/philippines-import";
import { defaultData as philippinesExportDefaultValues } from "../../routes/intel/default-values/philippines-export";
import { defaultData as vietnamImportDefaultValues } from "../../routes/intel/default-values/vietnam-import";
import { defaultData as vietnamExportDefaultValues } from "../../routes/intel/default-values/vietnam-export";
import { defaultData as BangladeshExportDefaultValues } from "@routes/intel/default-values/bangladesh-export";
import { defaultData as BangladeshImportDefaultValues } from "@routes/intel/default-values/bangladesh-import";
import { defaultData as GhanaImportDefaultValues } from "@routes/intel/default-values/ghana-import";
import { defaultData as NamibiaImportDefaultValues } from "@routes/intel/default-values/namibia-imports";
import { defaultData as NamibiaExportDefaultValues } from "@routes/intel/default-values/namibia-exports";
import { defaultData as RwandaImportDefaultValues } from "@routes/intel/default-values/rwanda-import";
import { defaultData as LesothoExportDefaultValues } from "@routes/intel/default-values/lesotho-export";
import { defaultData as LesothoImportDefaultValues } from "@routes/intel/default-values/lesotho-imports";
import { defaultData as KazakhstanImportDefaultValues } from "@routes/intel/default-values/kazakhstan-import";
import { defaultData as KazakhstanExportDefaultValues } from "@routes/intel/default-values/kazakhstan-export";
import { defaultData as NigeriaImportDefaultValues } from "@routes/intel/default-values/nigeria-import";
import { defaultData as PakistanImportDefaultValues } from "@routes/intel/default-values/pakistan-import";
import { defaultData as PakistanExportDefaultValues } from "@routes/intel/default-values/pakistan-export";
import { defaultData as CameroonImportDefaultValues } from "@routes/intel/default-values/cameroon-import";
import { defaultData as CameroonExportDefaultValues } from "@routes/intel/default-values/cameroon-export";
import { defaultData as GhanaExportDefaultValues } from "@routes/intel/default-values/ghana-export";
import { defaultData as BotswanaImportDefaultValues } from "@routes/intel/default-values/botswana-import";
import { defaultData as BotswanaExportDefaultValues } from "@routes/intel/default-values/botswana-export";
import { defaultData as IvoryCoastImportDefaultValues } from "@routes/intel/default-values/ivory-coast-import";
import { defaultData as IvoryCoastExportDefaultValues } from "@routes/intel/default-values/ivory-coast-export";
import { defaultData as NigeriaExportDefaultValues } from "@routes/intel/default-values/nigeria-export";
import { defaultData as UzbekistanExportDefaultValues } from "@routes/intel/default-values/uzbekistan-export";
import { defaultData as UzbekistanImportDefaultValues } from "@routes/intel/default-values/uzbekistan-imports";
import { defaultData as SriLankaImportDefaultValues } from "@routes/intel/default-values/srilanka-import";
import { defaultData as SriLankaExportDefaultValues } from "@routes/intel/default-values/srilanka-export";
import { defaultData as ParaguayImportDefaultValues } from "@routes/intel/default-values/paraguay-import";
import { defaultData as ParaguayExportDefaultValues } from "@routes/intel/default-values/paraguay-export";
import { defaultData as CostaRicaImportDefaultValues } from "@routes/intel/default-values/costa-rica-import";
import { defaultData as CostaRicaExportDefaultValues } from "@routes/intel/default-values/costa-rica-export";
import { defaultData as EthiopiaImportDefaultValues } from "@routes/intel/default-values/ethiopia-import";
import { defaultData as EthiopiaExportDefaultValues } from "@routes/intel/default-values/ethiopia-export";
import { defaultData as UgandaImportDefaultValues } from "@routes/intel/default-values/uganda-import";
import { defaultData as UgandaExportDefaultValues } from "@routes/intel/default-values/uganda-export";
import { defaultData as MexicoMaritimeImportDefaultValues } from "@routes/intel/default-values/mexico-import-maritime";
import { defaultData as MexicoMaritimeExportDefaultValues } from "@routes/intel/default-values/mexico-export-maritime";
import { defaultData as RussiaNmImportDefaultValues } from "@routes/intel/default-values/russia-import-nm";
import { defaultData as RussiaNmExportDefaultValues } from "@routes/intel/default-values/russia-export-nm";
import { defaultData as IndonesiaNmImportDefaultValues } from "@routes/intel/default-values/indonesia-import-nm";
import { defaultData as IndonesiaNmExportDefaultValues } from "@routes/intel/default-values/indonesia-export-nm";
import { defaultData as IndiaMirrorExportDefaultValues } from "@routes/intel/default-values/india-export-mirror";
import { defaultData as IndiaMirrorImportDefaultValues } from "@routes/intel/default-values/india-import-mirror";

const createShipmentObject = (defaultValues) => {
  return {
    apiUrl: defaultValues.apiEndPoints.getShipmentByID,
    viewShipmentObject: defaultValues.viewShipmentDetails,
    apiUrlDownload: defaultValues.apiEndPoints.getShipmentDownloadData,
    defaultKey: defaultValues,
  };
};

export const getViewShipmentDataDictionary = function (dataSource) {
  const data = {
    "ECUADOR EXPORTS": {
      apiUrl: ecaudorExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: ecaudorExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: ecaudorExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: ecaudorExportDefaultValues,
    },
    "ECUADOR IMPORTS": {
      apiUrl: ecaudorImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: ecaudorImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: ecaudorImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: ecaudorImportDefaultValues,
    },
    "US EXPORTS": {
      apiUrl: usExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: usExportDefaultValues.viewShipmentDetails,
      isViewShipmentURLModified: usExportDefaultValues.isViewShipmentURLModified,
      apiUrlDownload: usExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: usExportDefaultValues,
    },
    "US IMPORTS": {
      apiUrl: usImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: usImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: usImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: usImportDefaultValues,
    },
    "PANAMA IMPORTS": {
      apiUrl: panamaImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: panamaImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: panamaImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: panamaImportDefaultValues,
    },
    "PANAMA EXPORTS": {
      apiUrl: panamaExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: panamaExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: panamaExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: panamaExportDefaultValues,
    },
    "COLOMBIA IMPORTS": {
      apiUrl: colombiaImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: colombiaImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: colombiaImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: colombiaImportDefaultValues,
    },
    "COLOMBIA EXPORTS": {
      apiUrl: colombiaExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: colombiaExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: colombiaExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: colombiaExportDefaultValues,
    },
    "ARGENTINA IMPORTS": {
      apiUrl: argentinaImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: argentinaImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: argentinaImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: argentinaImportDefaultValues,
    },
    "ARGENTINA EXPORTS": {
      apiUrl: argentinaExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: argentinaExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: argentinaExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: argentinaExportDefaultValues,
    },
    "CHILE IMPORTS": {
      apiUrl: chileImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: chileImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: chileImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: chileImportDefaultValues,
    },
    "CHILE EXPORTS": {
      apiUrl: chileExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: chileExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: chileExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: chileExportDefaultValues,
    },
    "MEXICO IMPORTS": {
      apiUrl: mexicoImportExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: mexicoImportExportDefaultValues.viewShipmentDetails,
      isViewShipmentURLModified: usExportDefaultValues.isViewShipmentURLModified,
      apiUrlDownload: mexicoImportExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: mexicoImportExportDefaultValues,
    },
    "MEXICO EXPORTS": {
      apiUrl: mexicoExportExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: mexicoExportExportDefaultValues.viewShipmentDetails,
      isViewShipmentURLModified: usExportDefaultValues.isViewShipmentURLModified,
      apiUrlDownload: mexicoExportExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: mexicoExportExportDefaultValues,
    },
    "PERU IMPORTS": {
      apiUrl: peruImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: peruImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: peruImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: peruImportDefaultValues,
    },
    "PERU EXPORTS": {
      apiUrl: peruExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: peruExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: peruExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: peruExportDefaultValues,
    },
    "UK IMPORTS": {
      apiUrl: ukImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: ukImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: ukImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: ukImportDefaultValues,
    },
    "UK EXPORTS": {
      apiUrl: ukExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: ukExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: ukExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: ukExportDefaultValues,
    },
    "URUGUAY IMPORTS": {
      apiUrl: uruguayImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: uruguayImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: uruguayImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: uruguayImportDefaultValues,
    },
    "URUGUAY EXPORTS": {
      apiUrl: uruguayExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: uruguayExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: uruguayExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: uruguayExportDefaultValues,
    },
    "PHILIPPINES IMPORTS": {
      apiUrl: philippinesImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: philippinesImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: philippinesImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: philippinesImportDefaultValues,
    },
    "PHILIPPINES EXPORTS": {
      apiUrl: philippinesExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: philippinesExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: philippinesExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: philippinesExportDefaultValues,
    },
    "VIETNAM IMPORTS": {
      apiUrl: vietnamImportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: vietnamImportDefaultValues.viewShipmentDetails,
      apiUrlDownload: vietnamImportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: vietnamImportDefaultValues,
    },
    "VIETNAM EXPORTS": {
      apiUrl: vietnamExportDefaultValues.apiEndPoints.getShipmentByID,
      viewShipmentObject: vietnamExportDefaultValues.viewShipmentDetails,
      apiUrlDownload: vietnamExportDefaultValues.apiEndPoints.getShipmentDownloadData,
      defaultKey: vietnamExportDefaultValues,
    },
    "BOTSWANA IMPORTS": createShipmentObject(BotswanaImportDefaultValues),
    "BOTSWANA EXPORTS": createShipmentObject(BotswanaExportDefaultValues),
    "GHANA IMPORTS": createShipmentObject(GhanaImportDefaultValues),
    "GHANA EXPORTS": createShipmentObject(GhanaExportDefaultValues),
    "LESOTHO IMPORTS": createShipmentObject(LesothoImportDefaultValues),
    "LESOTHO EXPORTS": createShipmentObject(LesothoExportDefaultValues),
    "PAKISTAN IMPORTS": createShipmentObject(PakistanImportDefaultValues),
    "PAKISTAN EXPORTS": createShipmentObject(PakistanExportDefaultValues),
    "IVORY COAST IMPORTS": createShipmentObject(IvoryCoastImportDefaultValues),
    "IVORY COAST EXPORTS": createShipmentObject(IvoryCoastExportDefaultValues),
    "RWANDA IMPORTS": createShipmentObject(RwandaImportDefaultValues),
    "NAMIBIA IMPORTS": createShipmentObject(NamibiaImportDefaultValues),
    "NAMIBIA EXPORTS": createShipmentObject(NamibiaExportDefaultValues),
    "CAMEROON IMPORTS": createShipmentObject(CameroonImportDefaultValues),
    "CAMEROON EXPORTS": createShipmentObject(CameroonExportDefaultValues),
    "BANGLADESH IMPORTS": createShipmentObject(BangladeshImportDefaultValues),
    "BANGLADESH EXPORTS": createShipmentObject(BangladeshExportDefaultValues),
    "KAZAKHSTAN IMPORTS": createShipmentObject(KazakhstanImportDefaultValues),
    "KAZAKHSTAN EXPORTS": createShipmentObject(KazakhstanExportDefaultValues),
    "NIGERIA IMPORTS": createShipmentObject(NigeriaImportDefaultValues),
    "NIGERIA EXPORTS": createShipmentObject(NigeriaExportDefaultValues),
    "UZBEKISTAN IMPORTS": createShipmentObject(UzbekistanImportDefaultValues),
    "UZBEKISTAN EXPORTS": createShipmentObject(UzbekistanExportDefaultValues),
    "SRI LANKA IMPORTS": createShipmentObject(SriLankaImportDefaultValues),
    "SRI LANKA EXPORTS": createShipmentObject(SriLankaExportDefaultValues),
    "PARAGUAY IMPORTS": createShipmentObject(ParaguayImportDefaultValues),
    "PARAGUAY EXPORTS": createShipmentObject(ParaguayExportDefaultValues),
    "COSTA RICA IMPORTS": createShipmentObject(CostaRicaImportDefaultValues),
    "COSTA RICA EXPORTS": createShipmentObject(CostaRicaExportDefaultValues),
    "COSTA-RICA IMPORTS": createShipmentObject(CostaRicaImportDefaultValues),
    "COSTA-RICA EXPORTS": createShipmentObject(CostaRicaExportDefaultValues),
    "ETHIOPIA IMPORTS": createShipmentObject(EthiopiaImportDefaultValues),
    "ETHIOPIA EXPORTS": createShipmentObject(EthiopiaExportDefaultValues),
    "UGANDA IMPORTS": createShipmentObject(UgandaImportDefaultValues),
    "UGANDA EXPORTS": createShipmentObject(UgandaExportDefaultValues),
    "MEXICO MARITIME IMPORTS": createShipmentObject(MexicoMaritimeImportDefaultValues),
    "MEXICO MARITIME EXPORTS": createShipmentObject(MexicoMaritimeExportDefaultValues),
    "RUSSIA NM IMPORTS": createShipmentObject(RussiaNmImportDefaultValues),
    "RUSSIA NM EXPORTS": createShipmentObject(RussiaNmExportDefaultValues),
    "INDIA MIRROR IMPORTS": createShipmentObject(IndiaMirrorImportDefaultValues),
    "INDIA MIRROR EXPORTS": createShipmentObject(IndiaMirrorExportDefaultValues),
    "INDIA IMPORTS": createShipmentObject(IndiaMirrorImportDefaultValues),
    "INDIA EXPORTS": createShipmentObject(IndiaMirrorExportDefaultValues),
    "INDONESIA NM IMPORTS": createShipmentObject(IndonesiaNmImportDefaultValues),
    "INDONESIA NM EXPORTS": createShipmentObject(IndonesiaNmExportDefaultValues),
  };
  return data[dataSource];
};
